export const config = {
    appname: 'cpffeed',
    client_id: '1764763107262737', // App ID
    facebook_app_id: '1764763107262737', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api_prefix: 'apicff',
    agency_id: '197735',
    bzbsUrl: 'https://apicff.buzzebees.com',
    bzbsModuleUrl: 'https://cpfmodule.buzzebees.com',
    bzbsWallet: 'https://apicflwallet.buzzebees.com',
    bzbsModuleWallet: 'https://giftcardwalletmodule.buzzebees.com',
    bzbsAddItemFromList: 'https://apicfl.buzzebees.com/api/cart/',
    bzbsBlobUrl: 'https://cdn.buzzebees.com/th',
    apiShoppingCartUrl: 'https://shoppingcartmodule35.buzzebees.com',
    bzbsShoppingCartUrl: 'https://shoppingcartservice35.buzzebees.com',
    bzbNewShoppingCartUrl: 'https://shoppingcartproduct.buzzebees.com',
    bzbsAddItem: 'https://cartcfl.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://cartcfl.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://www.buzzebees.com',
    bzbsPointExpire: 'https://www.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '1654713008-raEmYnyj',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    mainConfig: {
        home_product: 'campaign_cpffeed_product',
        menu_product: 'menu_cpffeed_product',
        privilege: 'campaign_cpffeed_privilege',
        menu_privilege: 'menu_cpffeed_privilege',
        marketplace: 'campaign_bzbs',
        menu_marketplace: 'menu_campaign_bzbs',
        news: 'campaign_cpffeed_news',
        main_dashboard: 'cpffeed_dashboard',
        passcode_category: ['32776']
    },
    firebase: {
        apiKey: "AIzaSyB9YveyMxuHNt_WBfUeVKfR9r6c458kCUI",
        authDomain: "cpf-feed-production.firebaseapp.com",
        projectId: "cpf-feed-production",
        storageBucket: "cpf-feed-production.appspot.com",
        messagingSenderId: "436894827058",
        appId: "1:436894827058:web:16dc1f10d44ee2a57c322b",
        measurementId: "G-RJYSWZJPVZ"
    }
};
